import { Image } from 'src/components/ui/Image'
import { formatTableData } from 'src/utils/pdp/formatTableData'
import ArrowLeftClub from 'src/components/Icons/ArrowLeftClub'

import type { Product } from '../../../types/product'

type MiniPdpSizeTableProps = {
  product: Product
  onBack: () => void
}

export function MiniPdpSizeTable({ product, onBack }: MiniPdpSizeTableProps) {
  if (!product?.sizeDetails) {
    return null
  }

  const {
    how_to_measure: { subtitle, description, imageUrl },
    how_to_measure_details: howToMeasureDetails,
    conception_sizes_details: {
      conception_size_parameters: conceptionSizeParameters,
    },
  } = product.sizeDetails

  const { tableHeaderX, tableHeaderY } = formatTableData(
    conceptionSizeParameters
  )

  return (
    <section className="py-2">
      <button
        type="button"
        className="flex gap-3 items-center justify-center mb-4 text-2xl font-medium text-restructure-primary"
        onClick={onBack}
      >
        <ArrowLeftClub />
        Tabela de medidas
      </button>

      <div className="size-guide-table-wrapper my-4 overflow-x-auto w-full">
        <table className="size-guide-table text-sm w-full mb-4">
          <thead>
            <tr>
              <th className="w-[113px]" />
              {tableHeaderX.map((label, index) => (
                <th key={`${label}-${index}`} className="font-bold w-[152px]">
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableHeaderY.map((label, index) => {
              const rowValues = conceptionSizeParameters.map(({ sizes }) => {
                return sizes.find((size) => size.label === label)?.value
              })

              return (
                <tr
                  key={`${label}-${index}`}
                  className="last:border-b-0 border-y border-gray"
                >
                  <td>{label}</td>
                  {rowValues.map((value, valueIndex) => (
                    <td key={`${label}-${valueIndex}`}>{value}</td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {tableHeaderX.length > 3 && (
        <span className="text-tertiary text-sm">
          Arraste para o lado para ver mais
        </span>
      )}

      <div className="mt-8">
        <span className="text-xl font-medium text-restructure-primary">
          {subtitle}
        </span>
        <p className="mb-6 mt-3 text-secondary">{description}</p>

        <Image
          src={imageUrl}
          width={437}
          height={437}
          alt="Como medir"
          className="mx-auto h-auto w-full max-w-[340px] object-contain"
        />

        <div className="mt-8 text-secondary">
          {howToMeasureDetails.map(({ label, value }, index) => (
            <p key={`${label}-${index}`} className="my-4">
              <strong>{label}:</strong> {value}
            </p>
          ))}
        </div>
      </div>
    </section>
  )
}
